import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { GET, PUT, newFetch } from '../../../../../helpers/fetch';

const ManageDepartments = forwardRef(({ clientID }, ref) => {
  const [departments, setDepartments] = useState([]);
  const [savedDepartments, setSavedDepartments] = useState([]);

  const fetchDepartments = async () => {
    const apiPath =
      '/lu_fields/type/department/client/' + clientID + '?exact=true';
    const response = await newFetch(GET, apiPath);

    if (response?.success) {
      setDepartments(response.data);
      setSavedDepartments(JSON.parse(JSON.stringify(response.data)));
    } else {
      ToastUtil.error(response?.message || 'Unable to fetch departments');
    }
  };

  const updateDepartment = (index, value) => {
    const updatedDepartments = [...departments];
    updatedDepartments[index] = {
      ...updatedDepartments[index],
      label: value,
      value,
    };
    setDepartments(updatedDepartments);
  };

  const addDepartment = () => {
    setDepartments([
      ...departments,
      { label: '', value: '', client: Number(clientID) },
    ]);
  };

  const removeDepartment = (index) => {
    setDepartments(
      departments.filter(
        (department, departmentIndex) => departmentIndex !== index
      )
    );
  };

  const discardChanges = () => {
    setDepartments(JSON.parse(JSON.stringify(savedDepartments)));
  };

  const saveDepartments = async () => {
    const normalizedDepartments = departments.map((department) => ({
      ...department,
      label: department.label.trim(),
      value: department.label.trim(),
    }));

    if (normalizedDepartments.some((department) => !department.label)) {
      ToastUtil.error('Department names cannot be empty');
      return false;
    }

    const uniqueNames = new Set(
      normalizedDepartments.map((department) =>
        department.label.toLowerCase()
      )
    );
    if (uniqueNames.size !== normalizedDepartments.length) {
      ToastUtil.error('Department names must be unique');
      return false;
    }

    const apiPath = '/lu_fields/type/department/client/' + clientID;
    const response = await newFetch(PUT, apiPath, {
      fields: normalizedDepartments.map(({ id, label, value }) => ({
        id,
        label,
        value,
      })),
    });

    if (response?.success) {
      setDepartments(response.data);
      setSavedDepartments(JSON.parse(JSON.stringify(response.data)));
      return true;
    } else {
      ToastUtil.error(response?.message || 'Unable to update departments');
      return false;
    }
  };

  useImperativeHandle(ref, () => ({
    discardChanges,
    saveDepartments,
  }));

  useEffect(() => {
    fetchDepartments();
  }, [clientID]);

  return (
    <div
      className="border rounded d-flex"
      style={{
        marginTop: '2rem',
        marginLeft: '3rem',
        marginRight: '3rem',
        marginBottom: '8rem',
      }}
    >
      <div
        style={{
          width: '15rem',
          backgroundColor: '#f3f3f3',
          padding: '2.25rem',
        }}
        className="border-right"
      >
        <strong>Manage Departments</strong>
        <p className="pt-2">Manage departments for this client</p>
      </div>
      <div className="flex-grow-1 bg-white p-4 d-flex flex-column">
        <div className="d-flex justify-content-between mb-4 pb-2">
          <h5>Departments</h5>
        </div>

        <div className="row border-bottom mb-2 pb-2">
          <div className="col-8 fw-bold">Name</div>
          <div className="col-2 fw-bold text-center">Delete</div>
        </div>

        {departments.map((department, index) => (
          <div key={department.id || 'new-' + index} className="row py-2">
            <div className="col-8">
              <input
                type="text"
                className="form-control adjust-fs"
                value={department.label}
                onChange={(event) =>
                  updateDepartment(index, event.target.value)
                }
              />
            </div>
            <div
              className="col-2 text-center"
              style={{ cursor: 'pointer' }}
              onClick={() => removeDepartment(index)}
            >
              <i className="fas fa-trash pt-2"></i>
            </div>
          </div>
        ))}

        <button
          type="button"
          className="btn btn-block btn-outline-brand text-start mt-2 p-3 adjust-fs adjust-shadow"
          onClick={addDepartment}
        >
          <i className="fas fa-plus me-2" /> Add New Department
        </button>

      </div>
    </div>
  );
});

export default ManageDepartments;
